import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Main';
import reportWebVitals from './reportWebVitals';
import { ASSET_BASE } from './config';

// Legacy globals. Prefer importing from './config' in new code — these exist
// only because ~30 components still read `window.src_path`. Sourced from
// config so there is one place to change the asset origin.
window.server_path = `${ASSET_BASE.replace(/\/src$/, '')}/`;
window.src_path = `${ASSET_BASE}/`;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
